// ChatHeader.jsx
import React from 'react';

export default function ChatHeader({ hasItinerary, onDownload }) {
  return (
    <div className="p-6 border-b border-gray-200 flex flex-col sm:flex-row sm:items-center sm:justify-between text-center sm:text-left">
      <div>
        <h1 className="text-3xl font-bold text-gray-800">Your Trip Planner</h1>
        <p className="text-gray-600 mt-2">
          Let us build a complete trip itinerary in less than 5 minutes.
        </p>
      </div>
      {hasItinerary && (
        <button
          onClick={onDownload}
          className="mt-4 sm:mt-0 bg-blue-500 hover:bg-blue-600 text-white text-sm font-medium px-4 py-2 rounded-md transition"
        >
          Download PDF
        </button>
      )}
    </div>
  );
}
